import DatabaseReferenceIdAndKeyDto from "./../DatabaseReferenceIdAndKeyDto";

export default class DatabaseSelectionDto {

    constructor(database: DatabaseReferenceIdAndKeyDto | null) {
        this.Database = database;
    }

    Database: DatabaseReferenceIdAndKeyDto | null;
}